export const QUERY_PARAMS = {
  client: 'client',
  code: 'code',
  idToken: 'token',
  idTokenHint: 'id_token_hint'
} as const
